import { Avatar, Box, Checkbox } from "@mui/material";
import React, { useContext } from "react";
import { UserContext } from "../../..";
import EllipsisContent from "../../../../../Common/Component/EllipsisContent";

const PlayerCards = (props: any) => {
  const { selectedPlayer, setSelectedPlayer }: any =
    useContext(UserContext);
  const { players }: any = props
  return (
    <>
      {players.map((playersname: any) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            border: "1px solid #ccc",
            textAlign: "center",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", ml: 2 }}>
            <EllipsisContent text={`${playersname?.player_first_name} ${playersname?.player_last_name}`} />
          </Box>
          <Checkbox
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedPlayer([...selectedPlayer, playersname?.player_id]);
              } else {
                const index = selectedPlayer.findIndex(
                  (element: any) => element == playersname?.player_id
                );
                if (index != -1) {
                  const teamData = selectedPlayer.filter(
                    (e: any, ind: any) => ind != index
                  );

                  setSelectedPlayer(teamData);
                }
              }
            }}
            checked={selectedPlayer.includes(playersname?.player_id) ? true : false}
          />
        </Box>
      ))}
    </>
  );
};

export default PlayerCards;
